<template>
  <!-- Navbar -->
  <div class="navbar">
    <!-- Logo -->
    <div class="logo-container top-bar">
      <img alt="Vue logo" class="logo" :src="logo"/>
      <dots-horizontal
          class="navbar-collapser"
          @click="isNavbarCollapsed = !isNavbarCollapsed"
      />
    </div>
    <div class="left-navbar top-bar" :class="{ hidden: isNavbarCollapsed }">
      <!-- Channel select -->
      <navbar-channels-dropdown
          class="left-navbar__channels navbar__dropdown"
          :channels="channels"
          :current-channel-id="currentChannelId"
          @channelSelected="switchChannel"
      />
      <el-date-picker
          class="dataPickerStyle"
          v-if="$store.state.services.isMediaManager"
          v-model="dateRange"
          type="daterange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          >
      </el-date-picker>
      <navbar-calendar
          v-else
          @isShowCalendar="$emit('openCalendar')"
          @notifs="$emit('openNotifs')"
      />
    </div>

    <div class="right-navbar top-bar" :class="{ hidden: isNavbarCollapsed }">
      <!-- Socials dropdown to add/remove accounts -->
      <navbar-socials-dropdown
          class="right-navbar__socials navbar__dropdown"
          :socials="activeSocials"
          @addAccount="addAccount"
          @removeAccount="removeAccount"
      />
      <!-- Open buttons for shortcuts list & notifications panel -->
      <navbar-options
          :is-new-notif="isNewNotif"
          @shortcuts="$emit('openShortcuts')"
          @notifs="$emit('openNotifs')"
      />
    </div>
  </div>
</template>

<script>
import NavbarChannelsDropdown from "@/components/navbar/NavbarChannelsDropdown.vue";
import NavbarSocialsDropdown from "@/components/navbar/NavbarSocialsDropdown.vue";
import NavbarOptions from "@/components/navbar/NavbarOptions.vue";
import NavbarCalendar from "@/components/navbar/NavbarCalendar.vue";

/** Logo */
import logo from "@/assets/logo.png";

/** Icons */
import DotsHorizontal from "vue-material-design-icons/DotsHorizontal.vue";

// @group Navbar
// Navbar main panel
export default {
  name: "EditorNavbar",
  components: {
    NavbarChannelsDropdown,
    NavbarSocialsDropdown,
    NavbarOptions,
    DotsHorizontal,
    NavbarCalendar
  },
  model: {
    prop: "currentChannelId",
    event: "channelSelected"
  },
  props: {
    /** channels list */
    channels: {
      type: Array,
      required: true
    },
    /** selected channel ID */
    currentChannelId: {
      type: [String, Number],
      default: null
    },
    /** socials with connected account */
    activeSocials: {
      type: Object,
      default: () => new Object()
    },
    /** new notification received flag */
    isNewNotif: {
      type: Boolean,
      default: false
    },
    /** screen width pixels value from what navbar is collapsed */
    collapsingLimit: {
      type: Number,
      default: 992
    }
  },
  data() {
    return {
      isNavbarCollapsed: window.innerWidth < this.collapsingLimit,
      logo,
      dateRange: ''
    };
  },
  watch:{
    dateRange(value){
      if(value){
        this.$emit('changeDateRange', value)
      } else {
        this.$emit('changeDateRange', "")
      }
    }
  },
  methods: {
    // @vuese
    // Select channel
    // @arg id - new channel id
    switchChannel(id) {
      /** user selected channel */
      this.$emit("channelSelected", id);
      this.dateRange = ''
    },
    // @vuese
    // Connect new social account
    // @arg social - social name (google/facebook)
    addAccount(social) {
      this.$emit("addAccount", social);
    },
    // @vuese
    // Disconnect existing account
    // @arg removeData - <social, id> pair that identifies account
    removeAccount(removeData) {
      this.$emit("removeAccount", removeData);
    }
  }
};
</script>
<style>
.el-calendar-table thead th {
  color: black;
}
.el-date-editor .el-range-separator{
  color: #ccc !important;
}
.el-date-table__row .today div span{
  color: #409eff;
}
</style>

<style scoped lang="scss">
.dataPickerStyle{
  margin: 0px 10px
}

.navbar {
  display: flex;
  background-color: #233d4e;

  &__dropdown {
    color: white;
    font-size: 13px;
    font-family: "Arial";
  }
}

.logo-container {
  width: 150px;
}

.left-navbar {
  display: flex;
  justify-content: flex-start;
  flex-grow: 1;
  gap: 5px;
  align-items: center;
}

.right-navbar {
  width: 40%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.navbar-collapser {
  display: none;
}

/** Desktop */
@media only screen and (min-width: 992px) {
  .left-navbar {
    &__channels {
      margin-left: 15px;
    }
  }

  .right-navbar {
    justify-content: space-between;
    padding-right: 38px;
  }

  .navbar {
    &__dropdown {
      width: 150px;
      height: 50px;
      margin-top: auto;
      margin-bottom: auto;
    }
  }
}

/** Mobile */
@media only screen and (max-width: 991px) {
  .navbar {
    flex-direction: column;
    align-items: stretch;
  }

  .left-navbar,
  .right-navbar {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .navbar {
    &__dropdown {
      margin: 10px;
    }
  }

  .logo-container {
    width: 100%;
    padding-right: 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .navbar-collapser {
    color: white;
    display: block;
  }

  .top-bar.hidden {
    display: none;
  }
}
</style>

<style>
.navbar-selector {
  position: relative;
}
</style>
